// Auto-generated from octomil-contracts. Do not edit.

export enum PrincipalType {
  User = "user",
  OrgApiClient = "org_api_client",
  Device = "device",
  ServiceWorker = "service_worker",
}
